import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useUserData } from "../../../hooks/useUserData";
import { useInvalidate } from "../../../hooks/useInvalidate";
import { swingCollectionsService } from "../../../services/swingCollections";
import { useNewton } from "../../swing_library/components/Newton/store/NewtonContext";

export function useComparisonAiHighlight({ collectionOne, collectionTwo }) {
  const { userData } = useUserData();
  const { llmEnv } = useNewton();

  const invalidate = useInvalidate();
  const hasCollectionOneVideos = Boolean(collectionOne?.videoIds?.length);

  const result = useQuery({
    enabled: Boolean(userData?.uid && hasCollectionOneVideos),
    queryKey: [
      "comparisonAiHighlight_key",
      userData?.uid,
      collectionOne?.id,
      collectionTwo?.id,
      collectionOne?.videoIds?.join(","),
      collectionTwo?.videoIds?.join(","),
      llmEnv,
    ],
    queryFn: async () =>
      swingCollectionsService.getComparisonAiHighlight({
        collectionOneId: collectionOne?.id || "",
        collectionTwoId: collectionTwo?.id || "",
        userId: userData?.uid,
        overwriteEnv: llmEnv,
      }),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  useEffect(() => {
    if (result.data?.llmSessionId) {
      invalidate(["getLlmSessions_key"]);
    }
  }, [result.data?.llmSessionId, invalidate]);

  return result;
}
